<template>
    <MainContainer>
        <template v-slot:sidebar>&nbsp;</template>
        <div class="mitgliederstatistik">
            <h2>Mitgliederstatistik</h2>
            <section class="charts">
                <h5>
                    Auswertungen
                    <b-button v-b-toggle.charts size="sm">Einblenden/Ausblenden</b-button>
                </h5>
                <b-collapse id="charts" visible>
                    <template v-if="busy">
                        <CenteredMessage :spinner="true">
                            <template #title>Auswertungen werden generiert</template>
                        </CenteredMessage>
                    </template>
                    <template v-else>
                        <b-row>
                            <b-col cols="12">
                                <h6 class="text-center">Altersdurschnitt</h6>
                                <BarChart
                                    v-if="charts.age.loaded"
                                    :chartdata="charts.age.chartData"
                                    height="200"
                                />
                            </b-col>
                        </b-row>
                    </template>
                </b-collapse>
            </section>
            <hr />
            <section class="information">
                <h5>Informationen</h5>
                <Table
                    :responsive="true"
                    striped
                    bordered
                    showFilter
                    emptyText="Keine Mitgliedsdaten vorhanden"
                    busyText="Mitgliedsdaten werden geladen..."
                    :isBusy="busy"
                    :fields="fields"
                    :items="items"
                >
                    <template
                        v-slot:mean="{row: row}"
                    >{{Number(row.value).toLocaleString("de-DE", { maximumFractionDigits: 2, minimumFractionDigits: 2 })}}</template>
                </Table>
            </section>
        </div>
    </MainContainer>
</template>

<script>
import Size from "@/mixins/Size/Size";
import CommonView from "@/mixins/CommonView/CommonView";
import { ApiFactory } from "@/api/ApiFactory.js";
import MainContainer from "@/components/MainContainer/MainContainer";
import Table from "@/components/Table/Table";
import BarChart from "@/components/BarChart/BarChart";
import CenteredMessage from "@/components/CenteredMessage/CenteredMessage";

const MitgliederApi = ApiFactory.get("mitglieder");

export default {
    name: "MitgliederStatistik",
    mixins: [CommonView, Size],
    components: {
        MainContainer,
        Table,
        BarChart,
        CenteredMessage
    },
    data() {
        return {
            api: MitgliederApi,
            fields: [
                {
                    key: "label",
                    label: "Gruppe",
                    sortable: true
                },
                {
                    key: "mean",
                    label: "Durchschnittsalter",
                    sortable: true,
                    class: "text-right"
                },
                {
                    key: "amount",
                    label: "Anzahl d. Personen",
                    sortable: true,
                    class: "text-right"
                }
            ],
            items: [],
            charts: {
                age: {
                    loaded: false,
                    chartData: {}
                }
            }
        };
    },
    methods: {
        async fetch() {
            this.busy = true;
            const response = await this.api.getEvaluation();
            if (response.ok) {
                const items = response.json.collection.map(item => {
                    return {
                        label: item.label,
                        mean: item.data.age,
                        amount: item.data.amount
                    };
                });
                this.items = items;
                this.processAgeChart([...items]);
                // this.processWerkeMVChart([...items.werke]);
            }
            this.busy = false;
        },
        processAgeChart(items) {
            var chartData = {
                labels: [],
                datasets: []
            };

            var dataSetAgeTotalMean = {
                type: "line",
                label: "Durschnitt (gesamt)",
                backgroundColor: "#ff0000",
                borderColor: "rgba(255, 0, 0, 0.75)",
                data: [],
                fill: false,
                pointRadius: 0
            };
            var datasetAge = {
                label: "Durschnittsalter",
                data: []
            };

            var totalMean = 0;
            for (const item of items) {
                chartData.labels.push(item.label);
                datasetAge.data.push(item.mean);
                totalMean += Number(item.mean);
            }

            totalMean = totalMean / items.length;
            for (const _ of items) {
                dataSetAgeTotalMean.data.push(totalMean);
            }

            chartData.datasets.push(dataSetAgeTotalMean, datasetAge);

            this.charts.age.chartData = chartData;
            this.charts.age.loaded = !this.charts.age.loaded;
        }
    }
};
</script>
